export default __webpack_public_path__ + "static/N0014-79d1d5bb9a00c321a25cf4b03933382b.png";